module.exports = __webpack_public_path__ + "img/Food Safety Net Services.e1ba30b0.png";